import './Line.css'

const Line = ()=>{
    return(
        <div className='Line'>
            <div></div>
        </div>
    )
}
export default Line;